import { Route } from '@angular/router';

import { ComingSoonComponent, mediaGuard, NotFoundComponent, UserAuthGuard } from '@rp/core';
import { ProfileTarget, TargetApp } from '@rp/shared/models';
import { DetailsPageComponent, FinanceComponent } from '@rp/pages/finance';
import { tabsRouteMatcher } from '@rp/utils';

import { ShellComponent } from './shell/shell.component';

export const appRoutes: Route[] = [
  {
    path: 'storybook',
    loadComponent: () => import('@rp/storybook').then(m => m.StorybookComponent),
  },
  {
    path: 'confirm-payment-method',
    loadComponent: () =>
      import('@rp/pages/confirm-payment-method').then(m => m.ConfirmPaymentMethodComponent),
  },
  {
    path: '',
    component: ShellComponent,
    canActivate: [UserAuthGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'offers-wall',
      },
      {
        path: 'profile',
        loadComponent: () => import('@rp/pages/profile').then(m => m.ProfileComponent),
        data: {
          header: 'general.webmasterId',
          target: ProfileTarget.Webmaster,
          title: 'headerTitle.profile',
        },
      },
      {
        path: 'my-offers',
        loadComponent: () => import('@rp/pages/my-offers').then(m => m.MyOffersComponent),
        data: {
          title: 'headerTitle.myOffers',
          header: 'general.webmasterId',
          target: ProfileTarget.Webmaster,
        },
      },
      {
        path: 'offers-wall',
        loadComponent: () => import('@rp/pages/offers-wall').then(m => m.OffersWallComponent),
        data: {
          title: 'headerTitle.offersWall',
          header: 'general.webmasterId',
          target: ProfileTarget.Webmaster,
        },
      },
      {
        path: 'my-offers/:id',
        loadComponent: () => import('@rp/pages/my-offers').then(m => m.OfferInfoComponent),
      },
      {
        path: 'offers-wall/:id',
        loadComponent: () => import('@rp/pages/offers-wall').then(m => m.OfferWallInfoComponent),
      },
      {
        path: 'instruments',
        component: ComingSoonComponent,
      },
      {
        path: 'infrastructure',
        component: ComingSoonComponent,
      },
      {
        path: 'shop',
        component: ComingSoonComponent,
      },
      {
        path: 'faq',
        loadComponent: () => import('@rp/static-pages').then(m => m.FAQComponent),
      },
      {
        path: 'finance',
        component: FinanceComponent,
        data: {
          title: 'menu.finance',
        },
      },
      {
        path: 'finance/view',
        component: DetailsPageComponent,
        data: {
          title: 'menu.finance',
        },
      },
      {
        path: 'statistic',
        data: {
          target: TargetApp.Webmaster,
          title: 'statistic.statisticMainReport',
        },
        children: [
          {
            path: '',
            pathMatch: 'full',
            redirectTo: 'general',
          },
          {
            path: 'general/view',
            loadComponent: () =>
              import('@rp/pages/statistic').then(m => m.StatisticDetailsComponent),
            data: {
              target: TargetApp.Webmaster,
            },
          },
          {
            path: 'players/view',
            loadComponent: () =>
              import('@rp/pages/statistic').then(m => m.StatisticPlayersDetailsWebmasterComponent),
            data: {
              target: TargetApp.Webmaster,
            },
          },
          {
            matcher: tabsRouteMatcher,
            loadComponent: () => import('@rp/pages/statistic').then(m => m.StatisticComponent),
            data: {
              title: 'menu.statistic',
              target: TargetApp.Webmaster,
            },
          },
          {
            path: 'general',
            loadComponent: () =>
              import('@rp/pages/statistic').then(m => m.StatisticGeneralComponent),
          },
          {
            path: 'players',
            loadComponent: () =>
              import('@rp/pages/statistic').then(m => m.StatisticPlayersComponent),
          },
        ],
      },

      {
        path: '**',
        component: NotFoundComponent,
      },
    ],
  },
];
